import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertCircle, ChevronRight, CheckCircle2 } from "lucide-react";

// Beast V1 Checkpoint 4 — Needs You aggregator UI.
// Consumes the backend `/api/admin/needs-you` endpoint from CP3. We
// intentionally do NOT invent any frontend rules; we only render the
// items the backend returns. Empty list → restrained positive state.
export const NeedsYouPanel = ({ onNavigate }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api
      .get("/admin/needs-you")
      .then((r) => {
        if (!alive) return;
        setItems(Array.isArray(r.data?.items) ? r.data.items : []);
      })
      .catch(() => {
        if (!alive) return;
        setItems([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  // Deterministic mapping from backend key → in-app destination. Only
  // includes keys the backend can emit.
  const destinationFor = (key) => {
    if (key === "intake_needs_review" || key === "intake_clarification" || key === "intake_unknown_sender") {
      return "email-intake";
    }
    if (key === "jobs_overdue") return "jobs";
    return null;
  };

  return (
    <section data-testid="needs-you-panel" className="ur-card p-5">
      <div className="flex items-center gap-2 mb-4">
        <AlertCircle className="w-4 h-4 text-[#FF6600]" />
        <div className="ur-eyebrow">Needs You</div>
      </div>

      {loading ? (
        <div data-testid="needs-you-loading" className="text-sm text-[#A3A3A3] py-6 text-center">
          Loading…
        </div>
      ) : items.length === 0 ? (
        <div
          data-testid="needs-you-empty"
          className="flex items-center gap-2 text-sm text-[#A3A3A3] py-4"
        >
          <CheckCircle2 className="w-4 h-4 text-emerald-400" />
          Nothing needs your attention.
        </div>
      ) : (
        <ul className="space-y-2">
          {items.map((it) => {
            const dest = destinationFor(it.key);
            return (
              <li
                key={it.key}
                data-testid={`needs-you-item-${it.key}`}
                onClick={() => dest && onNavigate?.(dest)}
                className={`flex items-center gap-3 bg-[#0F0F0F] border border-[#1F1F1F] rounded-lg p-3 ${
                  dest ? "cursor-pointer hover:border-[#FF6600]" : ""
                }`}
              >
                <span
                  data-testid={`needs-you-count-${it.key}`}
                  className="inline-flex items-center justify-center min-w-[32px] h-8 px-2 rounded-full bg-[#FF6600] text-white text-xs font-bold"
                >
                  {it.count}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-white truncate">{it.label}</div>
                  <div className="text-xs text-[#A3A3A3] truncate">{it.why}</div>
                </div>
                {dest && <ChevronRight className="w-4 h-4 text-[#5A5A5A]" />}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};
